import i18next from 'i18next';

import {
  THEME_AKC,
  THEME_PET_PARTNERS,
  THEME_SPOT,
  MARKETING_CHANNEL_ID,
  THEME_PPU,
  PPU_MARKETING_CHANNELS,
} from './theme.constants';
import { getCompany, getStoreThemeId } from './theme.store';

import figoLogoDark
  from '../assets/brandLogos/dark-background/figo-logo.svg';
import figoLogoWhite from '../assets/figo-logo-white.svg';

import partnersLogoDark
  from '../assets/brandLogos/dark-background/petpartners-logo.svg';
import akcDark from '../assets/brandLogos/dark-background/akc-logo.svg';
import spotDark from '../assets/brandLogos/dark-background/spot-logo.svg';
import ppuDarkFr
  from '../assets/brandLogos/dark-background/ppu-logo-black-fr-CA.svg';
import ppuDarkUS
  from '../assets/brandLogos/dark-background/ppu-logo-black-en-US.svg';
import akcLogo from '../assets/brandLogos/simplified/akc-simplified.svg';
import ppiLogo from '../assets/brandLogos/simplified/ppi-simplified.svg';
import ppiOnePack from '../assets/brandProviderLogos/ppi-one-pack-logo.svg';
import spotLogo from '../assets/brandLogos/simplified/spot-simplified.svg';
import ppuLogo from '../assets/brandLogos/simplified/ppu-simplified.svg';
import akcWhiteLogo from '../assets/brandLogos/white/akc-logo-white.svg';
import ppiWhiteLogo from '../assets/brandLogos/white/ppi-logo-white.svg';
import ppiOPWhite from '../assets/brandLogos/white/ppi-onepack.svg';
import spotWhiteLogo from '../assets/brandLogos/white/spot-logo-white.svg';
import ppuWhiteLogoFr
  from '../assets/brandLogos/white/ppu-logo-white-fr-CA.png';
import ppuWhiteLogoUS
  from '../assets/brandLogos/white/ppu-logo-white-en-US.png';

// TODO: no dark icon provided yet
// import ppuPetCareDark
// from '../assets/brandLogos/white/ppu-pet-care-logo.svg';

// TODO: designers are working on providing svg instead of png
import ppuPetCareWhite
  from '../assets/brandLogos/white/ppu-pet-care-logo.png';
// TODO: no simplified icon provided yet
import ppuPetCareSimplified
  from '../assets/brandLogos/simplified/ppu-pet-care-simplified.svg';

import { LANGUAGES_FR_CA } from '../i18n';

export async function getTheme() {
  const defaultCompany = await getCompany();
  const defaultThemeId = defaultCompany.Id;

  return { company: defaultCompany, themeId: defaultThemeId };
}

export async function getThemeId() {
  const defaultTheme = await getStoreThemeId();

  return defaultTheme;
}

export function getThemeLogoById(themeId) {
  const { language } = i18next;

  let themeLogo = {
    dark: figoLogoDark,
    simplified: null,
    white: figoLogoWhite,
  };

  switch (parseInt(themeId, 10)) {
    case MARKETING_CHANNEL_ID.akc:
      themeLogo = {
        dark: akcDark,
        simplified: akcLogo,
        white: akcWhiteLogo,
      };
      break;
    case MARKETING_CHANNEL_ID.ppi:
      themeLogo = {
        dark: partnersLogoDark,
        simplified: ppiLogo,
        white: ppiWhiteLogo,
      };
      break;
    case MARKETING_CHANNEL_ID.ppiG:
      themeLogo = {
        dark: ppiOnePack,
        simplified: ppiLogo,
        white: ppiOPWhite,
      };
      break;
    case MARKETING_CHANNEL_ID.spot:
    case MARKETING_CHANNEL_ID.spotCan:
      themeLogo = {
        dark: spotDark,
        simplified: spotLogo,
        white: spotWhiteLogo,
      };
      break;

    case MARKETING_CHANNEL_ID.ppu:
      themeLogo = {
        dark: language === LANGUAGES_FR_CA ? ppuDarkFr : ppuDarkUS,
        simplified: ppuLogo,
        white: language === LANGUAGES_FR_CA ? ppuWhiteLogoFr : ppuWhiteLogoUS,
      };
      break;

    case MARKETING_CHANNEL_ID.ppuPetCare:
      themeLogo = {
        dark: ppuPetCareSimplified,
        simplified: ppuPetCareSimplified,
        white: ppuPetCareWhite,
      };
      break;

    default:
      themeLogo = {
        dark: figoLogoDark,
        simplified: null,
        white: figoLogoWhite,
      };
  }

  return themeLogo;
}

export async function getThemeLogo() {
  const themeFromStore = await getStoreThemeId();

  return getThemeLogoById(themeFromStore);
}

export function isOrcaCompany(companyId) {
  return [
    THEME_AKC,
    THEME_PET_PARTNERS,
    THEME_PPU,
    THEME_SPOT,
  ].includes(companyId);
}
/**
 * All kind of PPU policies are considered.
 * @param {*} marketChannelId of the current policy :)
 * @returns Boolean validation
 */
export const isPPUPolicy = (marketChannelId = 0) => {
  if (!marketChannelId) {
    return false;
  }

  return PPU_MARKETING_CHANNELS.includes(marketChannelId);
};

export const isPPUCorePolicy = (marketChannelId = 0) => {
  if (!marketChannelId) {
    return false;
  }

  return marketChannelId === MARKETING_CHANNEL_ID.ppuPetCare;
};

export const getCompanyName = (marketChannelId = 0) => {
  switch (marketChannelId) {
    case MARKETING_CHANNEL_ID.figo:
      return 'FIGO';
    case MARKETING_CHANNEL_ID.akc:
      return 'AKC';
    case MARKETING_CHANNEL_ID.ppi:
      return 'PPI';
    case MARKETING_CHANNEL_ID.ppiG:
      return 'PPiG';
    case MARKETING_CHANNEL_ID.spot:
    case MARKETING_CHANNEL_ID.spotCan:
      return 'SPOT';
    case MARKETING_CHANNEL_ID.ppu:
      return 'PPU Core';
    case MARKETING_CHANNEL_ID.ppuPetCare:
      return 'PPU Core 2';
    default:
      return '';
  }
};
